import Aqumen from "@aqumen/sdk";

import {Query} from "@/data/query.js";

export async function fetchJob(session, id) {
  const jobs = await Aqumen.Job.all(session, Query.Job.selection, {jobs: {id}});
  return jobs?.[0];
}
